export default "__VITE_ASSET__C7W8oX_I__"